  var ApiUrl        = "https://lens.hafsa.de/api:0octYcqs/"

  $(document).on("click","input.Error,select.Error",function(){
     $(this).removeClass("Error")
  })
  $(document).on("click",".CalcBox .CalcBoxContainer .TableBody .SelectedInput .SelectedInputWind ul>li:not(.Disabled)",function(){
     $("input").removeClass("Error")
  })

  $("#product-add-to-cart-control").click(function(){
    var ProdcutType   = prouctType($(".CalcBox").attr("ProductType"))
    var Upload        = $(".CalcBox").attr("Upload")
    var UploadId      = $(".CalcBox").attr("PrescriptionUploadId")
    var UploadPath    = $(".CalcBox").attr("PrescriptionUploadPath")
    var UploadMode    = $('[name="prescriptionOption"]:checked').val()

    console.log("ProdcutType",ProdcutType)
    console.log("Upload",Upload)
    // The migrated uploader returns a record ID and capability path, not File.
    // Never fall through to manual ordering while upload mode is selected.
    if(Upload==1 && (UploadMode=="upload" || (UploadMode==undefined && UploadId))){
      var dropzone = document.querySelector('.prescription-dropzone')
      var uploadBusy = dropzone && dropzone.dropzone && dropzone.dropzone.files.some(function(file){
        return ['added','queued','uploading'].indexOf(file.status) !== -1
      })
      var uploadReady = /^[0-9a-f-]{36}$/i.test(UploadId || '')
        && typeof UploadPath === 'string' && UploadPath.indexOf('/vault/' + UploadId + '/') === 0
      $('[data-prescription-checkout-error]').remove()
      if(uploadBusy || !uploadReady){
        $('<p/>', {'data-prescription-checkout-error':'',role:'alert',style:'color:#b42318;font-size:13px;margin:8px 0;'})
          .text(uploadBusy ? 'Reçetenizin yüklenmesi tamamlanana kadar bekleyiniz.' : 'Lütfen önce reçetenizi yükleyiniz.')
          .appendTo('.UploadBoxArea')
        return false
      }
      $("#product-add-to-cart").prop("disabled",false).trigger("click")
      return false
    }else{
      if(ProdcutType==6){
         var Type = $(".CalcBox").attr("T")
         if(Type==0){
           var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
           var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
           var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
           var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()
  
           var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
           var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
           var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
           var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()
  
           var Control      = 0
           
           if(Power_Left==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').addClass("Error"); Control = 1;}
           if(BC_Left=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').addClass("Error"); Control = 1;}
           if(DIA_Left=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').addClass("Error"); Control = 1;}
           if(Power_Right==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').addClass("Error"); Control = 1;}
           if(BC_Right=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').addClass("Error"); Control = 1;}
           if(DIA_Right=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').addClass("Error"); Control = 1;}
  
           if(Control==0){
             $("#product-add-to-cart").prop("disabled",false).trigger("click")
           }
         }
         if(Type==1){
           var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
           var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
           var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
           var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()
  
           var Control = 0
           if(Power==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').addClass("Error"); Control = 1 }
           if(BC=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').addClass("Error"); Control = 1 }
           if(DIA=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').addClass("Error"); Control = 1 }
  
           if(Control==0){
             $("#product-add-to-cart").prop("disabled",false).trigger("click")
           }
         }
      }
      if(ProdcutType==8){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var ADDITION_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()
  
         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var ADDITION_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()
  
         var Control = 0
   
         if(Power_Left==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').addClass("Error"); }
         if(BC_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').addClass("Error"); }
         if(DIA_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').addClass("Error"); }
         if(ADDITION_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Left"]').addClass("Error"); }
         if(Power_Right==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').addClass("Error"); }
         if(BC_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').addClass("Error"); }
         if(DIA_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').addClass("Error"); }
         if(ADDITION_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Right"]').addClass("Error"); }
  
         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
       if(Type==1){
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var Addition   = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_LeftRight"]').val()
         var Box   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()
  
         var Control = 0
         if(Power==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').addClass("Error"); Control = 1 }
         if(BC=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').addClass("Error"); Control = 1 }
         if(DIA=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').addClass("Error"); Control = 1 }
         if(Addition=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_LeftRight"]').addClass("Error"); Control = 1 }
  
         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
     }
      if(ProdcutType==9){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var Color_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()
  
         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var Color_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()
  
         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
  
         if($(".SelectedInput").attr("D")==1){
           Power_Left  = $('.CalcBox .SelectedInput.Power_Left select').val()
           Power_Right  = $('.CalcBox .SelectedInput.Power_Right select').val()
           if(Power_Left=="0"){ Control = 1; Control_Left = 1 }
           if(Power_Right=="0"){ Control = 1; Control_Right = 1 }
         }else{
           if(Power_Left==""){ Control = 1; Control_Left = 1 }
           if(Power_Right==""){ Control = 1; Control_Right = 1 }
         }
       
         if(BC_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').addClass("Error");}
         if(DIA_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').addClass("Error");}
         if(Color_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Left"]').addClass("Error");}
         if(BC_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').addClass("Error");}
         if(DIA_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').addClass("Error");}
         if(Color_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Right"]').addClass("Error");}
  
     
         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
       if(Type==1){
         
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var Color   = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_LeftRight"]').val()
         var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()
         console.log("Power",Power)
         console.log("BC",BC)
         console.log("DIA",DIA)
         console.log("Color",Color)
         console.log("BOX",BOX)
         console.log("SelectedInput",$(".SelectedInput").attr("D"))

         if($(".SelectedInput").attr("D")==1){
           Power  = $('.CalcBox .SelectedInput.Power_LeftRight select').val()
           console.log("Power",Power)
           if(Power=="0"){ Control = 1; Control_Left = 1 }
         }else{
           if(Power==""){ Control = 1; Control_Left = 1 }
         }

         console.log("Power",Power)
         console.log("Control",Control)
         var Control = 0
         if(Power==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').addClass("Error"); Control = 1 }
         if(BC=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').addClass("Error"); Control = 1 }
         if(DIA=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').addClass("Error"); Control = 1 }
         if(Color=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="Color_LeftRight"]').addClass("Error"); Control = 1 }
         console.log("---Control",Control)

         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
     }
      if(ProdcutType==11){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var DN_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DN_Left"]').val()
         var ADDITION_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()
  
         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var DN_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DN_Right"]').val()
         var ADDITION_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()
  
         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         if(Power_Left==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').addClass("Error");}
         if(BC_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').addClass("Error");}
         if(DIA_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').addClass("Error");}
         if(DN_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DN_Left"]').addClass("Error");}
         if(ADDITION_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Left"]').addClass("Error"); }
         if(Power_Right==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').addClass("Error");}
         if(BC_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').addClass("Error");}
         if(DIA_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').addClass("Error");}
         if(DN_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DN_Right"]').addClass("Error");}
         if(ADDITION_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Right"]').addClass("Error");}
  
         if(Control==0){
          $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
       if(Type==1){
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var ADDITION   = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_LeftRight"]').val()
         var DN   = $('.CalcBox .CalcBoxContainer .TableBody [name="DN_LeftRight"]').val()
         var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()
  
         var Control = 0
         if(Power==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').addClass("Error"); Control = 1 }
         if(BC=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').addClass("Error"); Control = 1 }
         if(DIA=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').addClass("Error"); Control = 1 }
         if(DN=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DN_LeftRight"]').addClass("Error"); Control = 1 }
         if(ADDITION=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_LeftRight"]').addClass("Error"); Control = 1 }
  
         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
     }
      if(ProdcutType==12){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var CYL_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_Left"]').val()
         var AXIS_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_Left"]').val()
         var COLOR_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()
  
         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var CYL_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_Right"]').val()
         var AXIS_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_Right"]').val()
         var COLOR_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="COLOR_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()
  
         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         if(Power_Left==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').addClass("Error");}
         if(BC_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').addClass("Error");}
         if(DIA_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').addClass("Error");}
         if(CYL_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_Left"]').addClass("Error");}
         if(AXIS_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_Left"]').addClass("Error"); }
         if(COLOR_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="COLOR_Left"]').addClass("Error"); }
         if(Power_Right==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').addClass("Error");}
         if(BC_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').addClass("Error");}
         if(DIA_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').addClass("Error");}
         if(CYL_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_Right"]').addClass("Error");}
         if(AXIS_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_Right"]').addClass("Error");}
         if(COLOR_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Right"]').addClass("Error");}
  
         if(Control==0){
          $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
       if(Type==1){
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var CYL   = $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_LeftRight"]').val()
         var AXIS   = $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_LeftRight"]').val()
         var COLOR   = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_LeftRight"]').val()
         var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()
  
         var Control = 0
         if(Power==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').addClass("Error"); Control = 1 }
         if(BC=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').addClass("Error"); Control = 1 }
         if(DIA=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').addClass("Error"); Control = 1 }
         if(CYL=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_LeftRight"]').addClass("Error"); Control = 1 }
         if(AXIS=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_LeftRight"]').addClass("Error"); Control = 1 }
         if(COLOR=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="Color_LeftRight"]').addClass("Error"); Control = 1 }
  
         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
     }
      if(ProdcutType==7){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var Cyl_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_Left"]').val()
         var Axis_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()
  
         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var Cyl_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_Right"]').val()
         var Axis_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()
  
         var Control = 0
         if(Power_Left==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').addClass("Error"); }
         if(BC_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').addClass("Error"); }
         if(DIA_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').addClass("Error"); }
         if(Cyl_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_Left"]').addClass("Error"); }
         if(Axis_Left=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_Left"]').addClass("Error"); }
         if(Power_Right==""){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').addClass("Error"); }
         if(BC_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').addClass("Error"); }
         if(DIA_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').addClass("Error"); }
         if(Cyl_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_Right"]').addClass("Error"); }
         if(Axis_Right=="0"){ Control = 1; $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_Right"]').addClass("Error"); }
  
  
         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
       if(Type==1){
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var Cyl   = $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_LeftRight"]').val()
         var Axis   = $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_LeftRight"]').val()
         var Box   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()
  
         var Control = 0
         if(Power==""){ $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').addClass("Error"); Control = 1 }
         if(BC=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').addClass("Error"); Control = 1 }
         if(DIA=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').addClass("Error"); Control = 1 }
         if(Axis=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_LeftRight"]').addClass("Error"); Control = 1 }
         if(Cyl=="0"){ $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_LeftRight"]').addClass("Error"); Control = 1 }
  
         if(Control==0){
           $("#product-add-to-cart").prop("disabled",false).trigger("click")
         }
       }
     }
    }
  })

  function formControl(ProdcutType){
     var ProductId     = $(".product-details").attr("ProductId")
     if(ProdcutType==6){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()

         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()

         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         if(Power_Left==""){ Control = 1; Control_Left = 1 }
         if(BC_Left=="0"){ Control = 1; Control_Left = 1 }
         if(DIA_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Power_Right==""){ Control = 1; Control_Right = 1 }
         if(BC_Right=="0"){ Control = 1; Control_Right = 1 }
         if(DIA_Right=="0"){ Control = 1; Control_Right = 1 }

         if(Control_Left==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Left,
              "bc": BC_Left,
              "dia": DIA_Left
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left : "+ data[0].shipping)
               }else{
                 $(".Shipping.Left").hide()
               }
           });
         }
         if(Control_Right==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Right,
              "bc": BC_Right,
              "dia": DIA_Right
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Right").show().attr("barcode",data[0].EANUPC).html("Right : "+ data[0].shipping)
               }else{
                 $(".Shipping.Right").hide()
               }
           });
         }

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Left,
              "bc": BC_Left,
              "dia": DIA_Left
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
             Note = Note + "Left \n"
             Note = Note + "Power : "+Power_Left+"\n"
             Note = Note + "BC : "+BC_Left+"\n"
             Note = Note + "DIA : "+DIA_Left+"\n"
             Note = Note + "BOX : "+BOX_Left+"\n"
             Note = Note + "\n"
             Note = Note + "Right \n"
             Note = Note + "Power : "+Power_Right+"\n"
             Note = Note + "BC : "+BC_Right+"\n"
             Note = Note + "DIA : "+DIA_Right+"\n"
             Note = Note + "BOX : "+BOX_Right+"\n"
             $("#product-add-to-cart").prop("disabled",false)
           })
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
       if(Type==1){
         
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()

         var Control = 0
         if(Power==""){ Control = 1 }
         if(BC=="0"){ Control = 1 }
         if(DIA=="0"){ Control = 1 }

         const BodyData ={
            "product_type_id": ProdcutType,
            "product_id": ProductId,
            "power": Power,
            "bc": BC,
            "dia": DIA
         }
         window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
         method: "POST",
         headers: {
         "Content-Type": "application/json",
         "Accept": "application/json"
         },
         body: JSON.stringify(BodyData)
         })
         .then(response => response.json())
         .then(data => {
             if(data[0].shipping!=""){
               $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left and Right : "+ data[0].shipping)
             }else{
               $(".Shipping.Left").hide()
             }
         });

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left \n"
           Note = Note + "Power : "+Power+"\n"
           Note = Note + "BC : "+BC+"\n"
           Note = Note + "DIA : "+DIA+"\n"
           Note = Note + "BOX : "+BOX+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
     }
     if(ProdcutType==8){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var ADDITION_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()

         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var ADDITION_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()

         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         if(Power_Left==""){ Control = 1; Control_Left = 1 }
         if(BC_Left=="0"){ Control = 1; Control_Left = 1 }
         if(DIA_Left=="0"){ Control = 1; Control_Left = 1 }
         if(ADDITION_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Power_Right==""){ Control = 1; Control_Right = 1 }
         if(BC_Right=="0"){ Control = 1; Control_Right = 1 }
         if(DIA_Right=="0"){ Control = 1; Control_Right = 1 }
         if(ADDITION_Right=="0"){ Control = 1; Control_Right = 1 }

         if(Control_Left==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Left,
              "bc": BC_Left,
              "dia": DIA_Left,
              "addition": ADDITION_Left
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left : "+ data[0].shipping)
               }else{
                 $(".Shipping.Left").hide()
               }
           });
         }
         if(Control_Right==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Right,
              "bc": BC_Right,
              "dia": DIA_Right,
              "addition": ADDITION_Right
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Right").show().attr("barcode",data[0].EANUPC).html("Right : "+ data[0].shipping)
               }else{
                 $(".Shipping.Right").hide()
               }
           });
         }

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left \n"
           Note = Note + "Power : "+Power_Left+"\n"
           Note = Note + "BC : "+BC_Left+"\n"
           Note = Note + "DIA : "+DIA_Left+"\n"
           Note = Note + "Addition : "+ADDITION_Left+"\n"
           Note = Note + "Box : "+BOX_Left+"\n"
           Note = Note + "\n"
           Note = Note + "Right \n"
           Note = Note + "Power : "+Power_Right+"\n"
           Note = Note + "BC : "+BC_Right+"\n"
           Note = Note + "DIA : "+DIA_Right+"\n"
           Note = Note + "Addition : "+ADDITION_Right+"\n"
           Note = Note + "Box : "+BOX_Right+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
       if(Type==1){
         
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var Addition   = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_LeftRight"]').val()
         var Box   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()

         var Control = 0
         if(Power==""){ Control = 1 }
         if(BC=="0"){ Control = 1 }
         if(DIA=="0"){ Control = 1 }
         if(Addition=="0"){ Control = 1 }

         const BodyData ={
            "product_type_id": ProdcutType,
            "product_id": ProductId,
            "power": Power,
            "bc": BC,
            "dia": DIA,
            "addition": Addition
         }
         window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
         method: "POST",
         headers: {
         "Content-Type": "application/json",
         "Accept": "application/json"
         },
         body: JSON.stringify(BodyData)
         })
         .then(response => response.json())
         .then(data => {
             if(data[0].shipping!=""){
               $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left and Right : "+ data[0].shipping)
             }else{
               $(".Shipping.Left").hide()
             }
         });

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left And Right\n"
           Note = Note + "Power : "+Power+"\n"
           Note = Note + "BC : "+BC+"\n"
           Note = Note + "DIA : "+DIA+"\n"
           Note = Note + "Addition : "+Addition+"\n"
           Note = Note + "Box : "+Box+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
     }
     if(ProdcutType==9){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var Color_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()

         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var Color_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()

         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         
         if($(".SelectedInput").attr("D")==1){
           Power_Left  = $('.CalcBox .SelectedInput.Power_Left select').val()
           Power_Right  = $('.CalcBox .SelectedInput.Power_Right select').val()
           if(Power_Left=="0"){ Control = 1; Control_Left = 1 }
           if(Power_Right=="0"){ Control = 1; Control_Right = 1 }
         }else{
           if(Power_Left==""){ Control = 1; Control_Left = 1 }
           if(Power_Right==""){ Control = 1; Control_Right = 1 }
         }

         
         
         if(BC_Left=="0"){ Control = 1; Control_Left = 1 }
         if(DIA_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Color_Left=="0"){ Control = 1; Control_Left = 1 }
         
         if(BC_Right=="0"){ Control = 1; Control_Right = 1 }
         if(DIA_Right=="0"){ Control = 1; Control_Right = 1 }
         if(Color_Right=="0"){ Control = 1; Control_Right = 1 }

         if(Control_Left==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Left,
              "bc": BC_Left,
              "dia": DIA_Left,
              "color": Color_Left
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left : "+ data[0].shipping)
               }else{
                 $(".Shipping.Left").hide()
               }
           });
         }
         if(Control_Right==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Right,
              "bc": BC_Right,
              "dia": DIA_Right,
              "color": Color_Right
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Right").show().attr("barcode",data[0].EANUPC).html("Right : "+ data[0].shipping)
               }else{
                 $(".Shipping.Right").hide()
               }
           });
         }

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left \n"
           Note = Note + "Power : "+Power_Left+"\n"
           Note = Note + "BC : "+BC_Left+"\n"
           Note = Note + "DIA : "+DIA_Left+"\n"
           Note = Note + "Color : "+Color_Left+"\n"
           Note = Note + "Box : "+BOX_Left+"\n"
           Note = Note + "\n"
           Note = Note + "Right \n"
           Note = Note + "Power : "+Power_Right+"\n"
           Note = Note + "BC : "+BC_Right+"\n"
           Note = Note + "DIA : "+DIA_Right+"\n"
           Note = Note + "Color : "+Color_Right+"\n"
           Note = Note + "Box : "+BOX_Right+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
       if(Type==1){
         
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var Color   = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_LeftRight"]').val()
         var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()

         if($(".SelectedInput").attr("D")==1){
           Power  = $('.CalcBox .SelectedInput.Power_LeftRight select').val()
           if(Power=="0"){ Control = 1; Control_Left = 1 }
         }else{
           if(Power==""){ Control = 1; Control_Left = 1 }
         }

         var Control = 0
         if(Power==""){ Control = 1 }
         if(BC=="0"){ Control = 1 }
         if(DIA=="0"){ Control = 1 }
         if(Color=="0"){ Control = 1 }

         const BodyData ={
            "product_type_id": ProdcutType,
            "product_id": ProductId,
            "power": Power,
            "bc": BC,
            "dia": DIA,
            "color": Color
         }
         window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
         method: "POST",
         headers: {
         "Content-Type": "application/json",
         "Accept": "application/json"
         },
         body: JSON.stringify(BodyData)
         })
         .then(response => response.json())
         .then(data => {
             if(data[0].shipping!=""){
               $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left and Right : "+ data[0].shipping)
             }else{
               $(".Shipping.Left").hide()
             }
         });

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left And Right \n"
           Note = Note + "Power : "+Power+"\n"
           Note = Note + "BC : "+BC+"\n"
           Note = Note + "DIA : "+DIA+"\n"
           Note = Note + "Color : "+Color+"\n"
           Note = Note + "Box : "+BOX+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
     }
     if(ProdcutType==11){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var ADDITION_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Left"]').val()
         var DN_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DN_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()

         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var ADDITION_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_Right"]').val()
         var DN_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DN_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()

         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         if(Power_Left==""){ Control = 1; Control_Left = 1 }
         if(BC_Left=="0"){ Control = 1; Control_Left = 1 }
         if(DIA_Left=="0"){ Control = 1; Control_Left = 1 }
         if(ADDITION_Left=="0"){ Control = 1; Control_Left = 1 }
         if(DN_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Power_Right==""){ Control = 1; Control_Right = 1 }
         if(BC_Right=="0"){ Control = 1; Control_Right = 1 }
         if(DIA_Right=="0"){ Control = 1; Control_Right = 1 }
         if(ADDITION_Right=="0"){ Control = 1; Control_Right = 1 }
         if(DN_Right=="0"){ Control = 1; Control_Right = 1 }


         if(Control_Left==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Left,
              "bc": BC_Left,
              "dia": DIA_Left,
              "addition": ADDITION_Left,
              "dn": DN_Left,
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left : "+ data[0].shipping)
               }else{
                 $(".Shipping.Left").hide()
               }
           });
         }
         if(Control_Right==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Right,
              "bc": BC_Left,
              "dia": DIA_Left,
              "addition": ADDITION_Right,
              "dn": DN_Right,
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Right").show().attr("barcode",data[0].EANUPC).html("Right : "+ data[0].shipping)
               }else{
                 $(".Shipping.Right").hide()
               }
           });
         }

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left \n"
           Note = Note + "Power : "+Power_Left+"\n"
           Note = Note + "BC : "+BC_Left+"\n"
           Note = Note + "DIA : "+DIA_Left+"\n"
           Note = Note + "ADDITION : "+ADDITION_Left+"\n"
           Note = Note + "DN : "+DN_Left+"\n"
           Note = Note + "BOX : "+BOX_Left+"\n"
           Note = Note + "\n"
           Note = Note + "Right \n"
           Note = Note + "Power : "+Power_Right+"\n"
           Note = Note + "BC : "+BC_Right+"\n"
           Note = Note + "DIA : "+DIA_Right+"\n"
           Note = Note + "ADDITION : "+ADDITION_Right+"\n"
           Note = Note + "DN : "+DN_Right+"\n"
           Note = Note + "BOX : "+BOX_Right+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
       if(Type==1){
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var ADDITION   = $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_LeftRight"]').val()
         var DN   = $('.CalcBox .CalcBoxContainer .TableBody [name="DN_LeftRight"]').val()
         var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()

         var Control = 0
         if(Power==""){ Control = 1 }
         if(BC=="0"){ Control = 1 }
         if(DIA=="0"){ Control = 1 }
         if(ADDITION=="0"){ Control = 1 }
         if(DN=="0"){ Control = 1 }

         const BodyData ={
            "product_type_id": ProdcutType,
            "product_id": ProductId,
            "power": Power,
            "bc": BC,
            "dia": DIA,
            "addition": ADDITION,
            "dn": DN,
         }
         window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
         method: "POST",
         headers: {
         "Content-Type": "application/json",
         "Accept": "application/json"
         },
         body: JSON.stringify(BodyData)
         })
         .then(response => response.json())
         .then(data => {
             if(data[0].shipping!=""){
               $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left and Right : "+ data[0].shipping)
             }else{
               $(".Shipping.Left").hide()
             }
         });

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left And Right\n"
           Note = Note + "Power : "+Power+"\n"
           Note = Note + "BC : "+BC+"\n"
           Note = Note + "DIA : "+DIA+"\n"
           Note = Note + "ADDITION : "+ADDITION+"\n"
           Note = Note + "DN : "+DN+"\n"
           Note = Note + "BOX : "+BOX+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
     }
     if(ProdcutType==12){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var AXIS_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_Left"]').val()
         var CYL_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_Left"]').val()
         var COLOR_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()

         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var AXIS_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_Right"]').val()
         var CYL_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_Right"]').val()
         var COLOR_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()

         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         if(Power_Left==""){ Control = 1; Control_Left = 1 }
         if(BC_Left=="0"){ Control = 1; Control_Left = 1 }
         if(DIA_Left=="0"){ Control = 1; Control_Left = 1 }
         if(AXIS_Left=="0"){ Control = 1; Control_Left = 1 }
         if(CYL_Left=="0"){ Control = 1; Control_Left = 1 }
         if(COLOR_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Power_Right==""){ Control = 1; Control_Right = 1 }
         if(BC_Right=="0"){ Control = 1; Control_Right = 1 }
         if(DIA_Right=="0"){ Control = 1; Control_Right = 1 }
         if(AXIS_Right=="0"){ Control = 1; Control_Right = 1 }
         if(CYL_Right=="0"){ Control = 1; Control_Right = 1 }
         if(COLOR_Right=="0"){ Control = 1; Control_Right = 1 }


         if(Control_Left==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Left,
              "bc": BC_Left,
              "dia": DIA_Left,
              "axis": AXIS_Left,
              "cyl": CYL_Left,
              "color": COLOR_Left
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left : "+ data[0].shipping)
               }else{
                 $(".Shipping.Left").hide()
               }
           });
         }
         if(Control_Right==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Right,
              "bc": BC_Left,
              "dia": DIA_Left,
              "axis": AXIS_Right,
              "cyl": CYL_Right,
              "color": COLOR_Right
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Right").show().attr("barcode",data[0].EANUPC).html("Right : "+ data[0].shipping)
               }else{
                 $(".Shipping.Right").hide()
               }
           });
         }

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left \n"
           Note = Note + "Power : "+Power_Left+"\n"
           Note = Note + "BC : "+BC_Left+"\n"
           Note = Note + "DIA : "+DIA_Left+"\n"
           Note = Note + "CYL : "+CYL_Left+"\n"
           Note = Note + "AXIS : "+AXIS_Left+"\n"
           Note = Note + "COLOR : "+COLOR_Left+"\n"
           Note = Note + "BOX : "+BOX_Left+"\n"
           Note = Note + "\n"
           Note = Note + "Right \n"
           Note = Note + "Power : "+Power_Right+"\n"
           Note = Note + "BC : "+BC_Right+"\n"
           Note = Note + "DIA : "+DIA_Right+"\n"
           Note = Note + "CYL : "+CYL_Right+"\n"
           Note = Note + "AXIS : "+AXIS_Right+"\n"
           Note = Note + "COLOR : "+COLOR_Right+"\n"
           Note = Note + "BOX : "+BOX_Right+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
       if(Type==1){
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var CYL   = $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_LeftRight"]').val()
         var AXIS   = $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_LeftRight"]').val()
         var COLOR   = $('.CalcBox .CalcBoxContainer .TableBody [name="Color_LeftRight"]').val()
         var BOX   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()

         var Control = 0
         if(Power==""){ Control = 1 }
         if(BC=="0"){ Control = 1 }
         if(DIA=="0"){ Control = 1 }
         if(CYL=="0"){ Control = 1 }
         if(AXIS=="0"){ Control = 1 }
         if(COLOR=="0"){ Control = 1 }

         const BodyData ={
            "product_type_id": ProdcutType,
            "product_id": ProductId,
            "power": Power,
            "bc": BC,
            "dia": DIA,
            "cyl": CYL,
            "axis": AXIS,
            "color": COLOR,
         }
         window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
         method: "POST",
         headers: {
         "Content-Type": "application/json",
         "Accept": "application/json"
         },
         body: JSON.stringify(BodyData)
         })
         .then(response => response.json())
         .then(data => {
             if(data[0].shipping!=""){
               $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left and Right : "+ data[0].shipping)
             }else{
               $(".Shipping.Left").hide()
             }
         });

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           Note = Note + "Left And Right\n"
           Note = Note + "Power : "+Power+"\n"
           Note = Note + "BC : "+BC+"\n"
           Note = Note + "DIA : "+DIA+"\n"
           Note = Note + "CYL : "+CYL+"\n"
           Note = Note + "AXIS : "+AXIS+"\n"
           Note = Note + "COLOR : "+COLOR+"\n"
           Note = Note + "BOX : "+BOX+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
     }
     if(ProdcutType==7){
       var Type = $(".CalcBox").attr("T")
       if(Type==0){
         var Power_Left  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Left"]').val()
         var BC_Left     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Left"]').val()
         var DIA_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Left"]').val()
         var Cyl_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_Left"]').val()
         var Axis_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_Left"]').val()
         var BOX_Left    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Left"]').val()

         var Power_Right  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_Right"]').val()
         var BC_Right     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_Right"]').val()
         var DIA_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_Right"]').val()
         var Cyl_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_Right"]').val()
         var Axis_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_Right"]').val()
         var BOX_Right    = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_Right"]').val()

         var Control = 0
         var Control_Left = 0
         var Control_Right = 0
         if(Power_Left==""){ Control = 1; Control_Left = 1 }
         if(BC_Left=="0"){ Control = 1; Control_Left = 1 }
         if(DIA_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Cyl_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Axis_Left=="0"){ Control = 1; Control_Left = 1 }
         if(Power_Right==""){ Control = 1; Control_Right = 1 }
         if(BC_Right=="0"){ Control = 1; Control_Right = 1 }
         if(DIA_Right=="0"){ Control = 1; Control_Right = 1 }
         if(Cyl_Right=="0"){ Control = 1; Control_Right = 1 }
         if(Axis_Right=="0"){ Control = 1; Control_Right = 1 }

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)

         
         if(Control_Left==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Left,
              "bc": BC_Left,
              "dia": DIA_Left,
              "cyl": Cyl_Left,
              "axis": Axis_Left
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left : "+ data[0].shipping)
               }else{
                 $(".Shipping.Left").hide()
               }
           });
         }
         if(Control_Right==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power_Right,
              "bc": BC_Right,
              "dia": DIA_Right,
              "cyl": Cyl_Right,
              "axis": Axis_Right
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Right").show().attr("barcode",data[0].EANUPC).html("Right : "+ data[0].shipping)
               }else{
                 $(".Shipping.Right").hide()
               }
           });
         }

         if(Control==0){
           Note = Note + "Left \n"
           Note = Note + "Power : "+Power_Left+"\n"
           Note = Note + "BC : "+BC_Left+"\n"
           Note = Note + "DIA : "+DIA_Left+"\n"
           Note = Note + "Cyl : "+Cyl_Left+"\n"
           Note = Note + "Axis : "+Axis_Left+"\n"
           Note = Note + "Box : "+BOX_Left+"\n"
           Note = Note + "\n"
           Note = Note + "Right \n"
           Note = Note + "Power : "+Power_Right+"\n"
           Note = Note + "BC : "+BC_Right+"\n"
           Note = Note + "DIA : "+DIA_Right+"\n"
           Note = Note + "Cyl : "+Cyl_Right+"\n"
           Note = Note + "Axis : "+Axis_Right+"\n"
           Note = Note + "Box : "+BOX_Right+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
       if(Type==1){
         var Power  = $('.CalcBox .CalcBoxContainer .TableBody [name="Power_LeftRight"]').val()
         var BC     = $('.CalcBox .CalcBoxContainer .TableBody [name="BC_LeftRight"]').val()
         var DIA   = $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_LeftRight"]').val()
         var Cyl   = $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_LeftRight"]').val()
         var Axis   = $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_LeftRight"]').val()
         var Box   = $('.CalcBox .CalcBoxContainer .TableBody [name="BOX_LeftRight"]').val()

         var Control = 0
         if(Power==""){ Control = 1 }
         if(BC=="0"){ Control = 1 }
         if(DIA=="0"){ Control = 1 }
         if(Axis=="0"){ Control = 1 }
         if(Cyl=="0"){ Control = 1 }

         $('[name="quantity"],[name="plus"],[name="minus"]').prop("disabled",false)
         if(Control==0){
           const BodyData ={
              "product_type_id": ProdcutType,
              "product_id": ProductId,
              "power": Power,
              "bc": BC,
              "dia": DIA,
              "cyl": Cyl,
              "axis": Axis
           }
           window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/' , {
           method: "POST",
           headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           },
           body: JSON.stringify(BodyData)
           })
           .then(response => response.json())
           .then(data => {
               if(data[0].shipping!=""){
                 $(".Shipping.Left").show().attr("barcode",data[0].EANUPC).html("Left and Right : "+ data[0].shipping)
               }else{
                 $(".Shipping.Left").hide()
               }
           });
           
           Note = Note + "Left And Right \n"
           Note = Note + "Power : "+Power+"\n"
           Note = Note + "BC : "+BC+"\n"
           Note = Note + "DIA : "+DIA+"\n"
           Note = Note + "Cyl : "+Cyl+"\n"
           Note = Note + "Axis : "+Axis+"\n"
           Note = Note + "Box : "+Box+"\n"
           $("#product-add-to-cart").prop("disabled",false)
         }else{
           Note = ""
           $("#product-add-to-cart").prop("disabled",true)
         }
       }
     }
  }
  function prouctType(TYPE){
    if(TYPE=="Astigmatlı Toric Lensler"){
      return 7
    }
    if(TYPE=="Multifocal Lens Biofinity"){
      return 11
    }
    if(TYPE=="Renkli Lensler"){
      return 9
    }
    if(TYPE=="Multifocal Lens"){
      return 8
    }
    if(TYPE=="Şeffaf Lensler"){
      return 6
    }
    if(TYPE=="Astigmatlı Renkli Lens"){
      return 12
    }
  }



$(document).ready(function(){
  var ProductType   = $(".CalcBox").attr("ProductType")
  var ProdcutType   = prouctType(ProductType)
  var ProductId     = $(".product-details").attr("ProductId")

  // The lens configurator exists only for the six API-backed product types.
  // Do not send invalid product/undefined/undefined requests from collection,
  // home, solution or eye-drop pages, and do not disable their add button.
  if(!ProdcutType || !ProductId){
    return
  }

  $("#product-add-to-cart").prop("disabled",true)
  var ApiUrl        = "https://lens.hafsa.de/api:0octYcqs/"

   $(".CalcBox .Title>div:last").click(function(){
    var Status = $(".CalcBox").attr("T")
    if(Status==0){
      $(".CalcBox").attr("T",1)
    }else{
      $(".CalcBox").attr("T",0)
    }
    $(".Shipping.Left").hide()
    $(".Shipping.Right").hide()

    if($(".SelectedInput").attr("D")!=1){
      $('.CalcBox .CalcBoxContainer .TableBody input[name="Power_LeftRight"]').val("")
      $('.CalcBox .CalcBoxContainer .TableBody input[name="Power_Left"]').val("")
      $('.CalcBox .CalcBoxContainer .TableBody input[name="Power_Right"]').val("")
    }else{
      $('.CalcBox .CalcBoxContainer .TableBody select.POWER>option[value="0"]').prop("selected",true)
    }
    $('.CalcBox .CalcBoxContainer .TableBody select:not(.POWER)').html('<option value="0"></option>')
    $('.CalcBox .CalcBoxContainer .TableBody select:not(.POWER)').html('<option value="0"></option>')
    $('.CalcBox .CalcBoxContainer .TableBody select:not(.POWER)').html('<option value="0"></option>')
    $('.CalcBox .CalcBoxContainer .TableBody select:not(.POWER)').html('<option value="0"></option>')
    $('.CalcBox .CalcBoxContainer .TableBody select:not(.POWER)').html('<option value="0"></option>')
    $('.CalcBox .CalcBoxContainer .TableBody select:not(.POWER)').html('<option value="0"></option>')


    $(".CalcBox .CalcBoxContainer .TableBody [name='BOX_Left']").html('<option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option>')
    $(".CalcBox .CalcBoxContainer .TableBody [name='BOX_Right']").html('<option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option>')
    $(".CalcBox .CalcBoxContainer .TableBody [name='BOX_LeftRight']").html('<option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option>')

     $("input.Error,select.Error").removeClass("Error")

     var TYPE = $(".CalcBox").attr("T") 
     var QU = 0
     if(TYPE==0){
        var BOX_Left      = parseInt($(".CalcBox .CalcBoxContainer .TableBody [name='BOX_Left']").val())
        var BOX_Right     = parseInt($(".CalcBox .CalcBoxContainer .TableBody [name='BOX_Right']").val())
         QU = BOX_Left + BOX_Right
     }
     if(TYPE==1){
        var BOX_LeftRight = parseInt($(".CalcBox .CalcBoxContainer .TableBody [name='BOX_LeftRight']").val())
       QU = BOX_LeftRight
     }
     $('[name="quantity"]').val(QU)
    
     formControl(ProdcutType)
  })


   var CatalogUrl = ApiUrl + 'product/'+ProdcutType+'/'+ProductId
   var BootstrapCatalog = window.lensCatalogBootstrap
   var CatalogRequest = BootstrapCatalog && BootstrapCatalog.url === CatalogUrl
      ? BootstrapCatalog.promise
      : window.lensCatalogRequest(CatalogUrl, {
          method: "GET",
          headers: {
             "Accept": "application/json"
          }
        }).then(response => response.json())

   CatalogRequest
   .then(data => {
       if(!data || !data.power || data.power.length==0){
          window.lensCatalogShowError()
          return
       }
       window.lensCatalogHideError()
       var ProdcutType   = prouctType($(".CalcBox").attr("ProductType"))
       var ProductId     = $(".product-details").attr("ProductId")
       var PowerList = [];
       console.log("ProdcutType3",ProdcutType)
      if(data.power.length==1){
          var ProdcutType = prouctType($(".CalcBox").attr("ProductType"))
          var ProductId   = $(".product-details").attr("ProductId")
        
          $(".SelectedInput").attr("D",data.power.length)
          $(".SelectedInput").append(`
          <select class="POWER">
            <option value="0"></option>
            <option value="${data.power[0].power}">${data.power[0].power}</option>
          </select>
          `)
          $(".SelectedInput input").hide()

          if(ProdcutType==9){
            
           if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()==undefined){
              if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()==undefined){
                $('.CalcBox .CalcBoxContainer .TableBody select.POWER').change(function() {
                    
                   var Position   = $(this).closest(".SelectedInput").attr("Position")
                   var Bc    = $('[name="BC_'+Position+'"]').val()
                   var Dia   = $('[name="DIA_'+Position+'"]').val()
                   var Power = $(this).val()
      
                    $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                             
                   const BodyData ={
                      "product_type_id": ProdcutType,
                      "product_id": ProductId,
                      "bc": Bc,
                      "dia": Dia,
                      "power": Power
                   }
                   window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/n-color/' , {
                   method: "POST",
                   headers: {
                   "Content-Type": "application/json",
                   "Accept": "application/json"
                   },
                   body: JSON.stringify(BodyData)
                   })
                   .then(response => response.json())
                   .then(data => {
                      var List = [];
                      $.each(data, function(index, item) {
                         var isExist = List.some(function(currentValue) {
                            return item.color === currentValue.color;
                         });
                         if (!isExist) {
                            List.push(item);
                         }
                      });
                      List.sort(function(a, b) {
                         return parseFloat(a.color) - parseFloat(b.color);
                      });
                      $.each(List, function(i, itemx) {
                         $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').append('<option value="' + itemx.color + '">' + itemx.color + '</option>')
                      })
                   });
                   formControl(ProdcutType)
               });
             }else{
                $('.CalcBox .CalcBoxContainer .TableBody select.POWER').change(function() {
                    
                   var Position   = $(this).closest(".SelectedInput").attr("Position")
                   var Bc    = $('[name="BC_'+Position+'"]').val()
                   var Power = $(this).val()
      
                    $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                    $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                             
                   const BodyData ={
                      "product_type_id": ProdcutType,
                      "product_id": ProductId,
                      "bc": Bc,
                      "power": Power
                   }
                   window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                   method: "POST",
                   headers: {
                   "Content-Type": "application/json",
                   "Accept": "application/json"
                   },
                   body: JSON.stringify(BodyData)
                   })
                   .then(response => response.json())
                   .then(data => {
                      var List = [];
                      $.each(data, function(index, item) {
                         var isExist = List.some(function(currentValue) {
                            return item.dia === currentValue.dia;
                         });
                         if (!isExist) {
                            List.push(item);
                         }
                      });
                      List.sort(function(a, b) {
                         return parseFloat(a.dia) - parseFloat(b.dia);
                      });
                      $.each(List, function(i, itemx) {
                         $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                      })
                   });
                   formControl(ProdcutType)
               });
             }
           }else{
              $('.CalcBox .CalcBoxContainer .TableBody select.POWER').change(function() {
                  
                 var Position   = $(this).closest(".SelectedInput").attr("Position")
                 var Power = $(this).val()
    
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/bc/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.bc === currentValue.bc;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.bc) - parseFloat(b.bc);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="BC_'+Position+'"]').append('<option value="' + itemx.bc + '">' + itemx.bc + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
           }
            
           if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.BC').change(function() {
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
    
                  $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.dia === currentValue.dia;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.dia) - parseFloat(b.dia);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
           }
           if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.DIA').change(function() {
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
                 var Dia   = $('[name="DIA_'+Position+'"]').val()
               
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
               
                 
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc,
                    "dia": Dia
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/color/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.color === currentValue.color;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.color) - parseFloat(b.color);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').append('<option value="' + itemx.color + '">' + itemx.color + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
           }
           $('.CalcBox .CalcBoxContainer .TableBody select.COLOR').change(function() {
              formControl(ProdcutType)
           });
         }
      }else{

        
        
          $.each(data.power, function(index, item) {
             var isExist = PowerList.some(function(currentValue) {
                return item.power === currentValue.power;
             });
             if (!isExist) {
                PowerList.push(item);
             }
          });
          PowerList.sort(function(a, b) {
             return parseFloat(a.power.replace("-", "")) - parseFloat(b.power.replace("-", ""));
          });
          $.each(PowerList, function(i, itemx) {
             if(itemx.power.indexOf("-") != -1) {
                $('.CalcBox .CalcBoxContainer .TableBody .SelectedInput .SelectedInputWind ul.Minus').append('<li value="' + itemx.power + '">' + itemx.power + '</li>')
             }
          })
          var PowerList = [];
          $.each(data.power, function(index, item) {
             var isExist = PowerList.some(function(currentValue) {
                return item.power === currentValue.power;
             });
             if (!isExist) {
                PowerList.push(item);
             }
          });
          PowerList.sort(function(a, b) {
             return parseFloat(a.power.replace("+", "")) - parseFloat(b.power.replace("+", ""));
          });
          $.each(PowerList, function(i, itemx) {
             if (itemx.power.indexOf("+") != -1) {
                $('.CalcBox .CalcBoxContainer .TableBody .SelectedInput .SelectedInputWind ul.Plus').append('<li value="' + itemx.power + '">' + itemx.power + '</li>')
             }
          })
          $(".CalcBox .CalcBoxContainer .TableBody .SelectedInput .SelectedInputWind ul>li:not(.Disabled)").click(function() {
              var ProdcutType= prouctType($(".CalcBox").attr("ProductType"))
              var ProductId  = $(".product-details").attr("ProductId")
              var Power      = $(this).attr("value")
              var Position   = $(this).closest(".SelectedInput").attr("Position")
              $(this).closest(".SelectedInput").find("input").val(Power)
              $(".CalcBox .CalcBoxContainer .TableBody .SelectedInput .SelectedInputWind ul>li").removeClass("Active")
              $(this).addClass("Active")
        
              $('.CalcBox .CalcBoxContainer .TableBody [name="BC_'+Position+'"]').html('<option value="0"></option>')
              $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_'+Position+'"]').html('<option value="0"></option>')
              $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_'+Position+'"]').html('<option value="0"></option>')
              $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
              $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
              $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').html('<option value="0"></option>')
              $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
              $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
              if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()!=undefined){
                var Power = $('[name="Power_'+Position+'"]').val()
                const BodyData ={
                  "product_type_id": ProdcutType,
                  "product_id": ProductId,
                  "power": Power
               }
               window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/bc/' , {
               method: "POST",
               headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
               },
               body: JSON.stringify(BodyData)
               })
               .then(response => response.json())
               .then(data => {
                  var List = [];
                  $.each(data, function(index, item) {
                     var isExist = List.some(function(currentValue) {
                        return item.bc === currentValue.bc;
                     });
                     if (!isExist) {
                        List.push(item);
                     }
                  });
                  List.sort(function(a, b) {
                     return parseFloat(a.bc) - parseFloat(b.bc);
                  });
                  $.each(List, function(i, itemx) {
                     $('.CalcBox .CalcBoxContainer .TableBody select[name="BC_'+Position+'"]').append('<option value="' + itemx.bc + '">' + itemx.bc + '</option>')
                  })
               });
              }else{
                if(ProdcutType==7){
                      var Power      = $('[name="Power_'+Position+'"]').val()
                      var Bc         = $('[name="BC_'+Position+'"]').val()
                      
                      $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                               
                      const BodyData ={
                        "product_type_id": ProdcutType,
                        "product_id": ProductId,
                        "power": Power,
                        "bc": Bc
                      }
                      window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/cyl/' , {
                      method: "POST",
                      headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                      },
                      body: JSON.stringify(BodyData)
                      })
                      .then(response => response.json())
                      .then(data => {
                        var List = [];
                        $.each(data, function(index, item) {
                           var isExist = List.some(function(currentValue) {
                              return item.cyl === currentValue.cyl;
                           });
                           if (!isExist) {
                              List.push(item);
                           }
                        });
                        List.sort(function(a, b) {
                           return parseFloat(a.cyl) - parseFloat(b.cyl);
                        });
                        $.each(List, function(i, itemx) {
                           $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_'+Position+'"]').append('<option value="' + itemx.cyl + '">' + itemx.cyl + '</option>')
                        })
                      });
                      formControl(ProdcutType)
                }
                if(ProdcutType==11){
                      var Power = $('[name="Power_'+Position+'"]').val()
                      var Bc    = $('[name="BC_'+Position+'"]').val()
                      
                      $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').html('<option value="0"></option>')
                               
                      const BodyData ={
                        "product_type_id": ProdcutType,
                        "product_id": ProductId,
                        "power": Power,
                        "bc": Bc
                      }
                      window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/addition/' , {
                      method: "POST",
                      headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                      },
                      body: JSON.stringify(BodyData)
                      })
                      .then(response => response.json())
                      .then(data => {
                        var List = [];
                        $.each(data, function(index, item) {
                           var isExist = List.some(function(currentValue) {
                              return item.addition === currentValue.addition;
                           });
                           if (!isExist) {
                              List.push(item);
                           }
                        });
                        List.sort(function(a, b) {
                           return parseFloat(a.addition) - parseFloat(b.addition);
                        });
                        $.each(List, function(i, itemx) {
                           $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').append('<option value="' + itemx.addition + '">' + itemx.addition + '</option>')
                        })
                      });
                      formControl(ProdcutType)
                }
                if(ProdcutType==12){
                    if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
                      var Power = $('[name="Power_'+Position+'"]').val()
                      var Bc    = $('[name="BC_'+Position+'"]').val()
                      
                      $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                               
                      const BodyData ={
                        "product_type_id": ProdcutType,
                        "product_id": ProductId,
                        "power": Power,
                        "bc": Bc
                      }
                      window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                      method: "POST",
                      headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                      },
                      body: JSON.stringify(BodyData)
                      })
                      .then(response => response.json())
                      .then(data => {
                        var List = [];
                        $.each(data, function(index, item) {
                           var isExist = List.some(function(currentValue) {
                              return item.dia === currentValue.dia;
                           });
                           if (!isExist) {
                              List.push(item);
                           }
                        });
                        List.sort(function(a, b) {
                           return parseFloat(a.dia) - parseFloat(b.dia);
                        });
                        $.each(List, function(i, itemx) {
                           $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                        })
                      });
                      formControl(ProdcutType)
                    }else{
                      var Power = $('[name="Power_'+Position+'"]').val()
                      var Bc    = $('[name="BC_'+Position+'"]').val()
                      var Dia    = $('[name="DIA_'+Position+'"]').val()
                      
                      $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                               
                      const BodyData ={
                        "product_type_id": ProdcutType,
                        "product_id": ProductId,
                        "power": Power,
                        "dia": Dia,
                        "bc": Bc
                      }
                      window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/cyl/' , {
                      method: "POST",
                      headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                      },
                      body: JSON.stringify(BodyData)
                      })
                      .then(response => response.json())
                      .then(data => {
                        var List = [];
                        $.each(data, function(index, item) {
                           var isExist = List.some(function(currentValue) {
                              return item.cyl === currentValue.cyl;
                           });
                           if (!isExist) {
                              List.push(item);
                           }
                        });
                        List.sort(function(a, b) {
                           return parseFloat(a.cyl) - parseFloat(b.cyl);
                        });
                        $.each(List, function(i, itemx) {
                           $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_'+Position+'"]').append('<option value="' + itemx.cyl + '">' + itemx.cyl + '</option>')
                        })
                      });
                      formControl(ProdcutType)
                    }
                }
                if(ProdcutType==9){
                  if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
                      var Power = $('[name="Power_'+Position+'"]').val()
                      var Bc    = $('[name="BC_'+Position+'"]').val()
                      
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                             
                      const BodyData ={
                      "product_type_id": ProdcutType,
                      "product_id": ProductId,
                      "power": Power,
                      "bc": Bc
                      }
                      window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                      method: "POST",
                      headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                      },
                      body: JSON.stringify(BodyData)
                      })
                      .then(response => response.json())
                      .then(data => {
                      var List = [];
                      $.each(data, function(index, item) {
                         var isExist = List.some(function(currentValue) {
                            return item.dia === currentValue.dia;
                         });
                         if (!isExist) {
                            List.push(item);
                         }
                      });
                      List.sort(function(a, b) {
                         return parseFloat(a.dia) - parseFloat(b.dia);
                      });
                      $.each(List, function(i, itemx) {
                         $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                      })
                      });
                      formControl(ProdcutType)
                  }else{
                       var Power = $('[name="Power_'+Position+'"]').val()
                       var Bc    = $('[name="BC_'+Position+'"]').val()
                       var Dia   = $('[name="DIA_'+Position+'"]').val()
                     
                        $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                     
                       
                       const BodyData ={
                          "product_type_id": ProdcutType,
                          "product_id": ProductId,
                          "power": Power,
                          "bc": Bc,
                          "dia": Dia
                       }
                       window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/color/' , {
                       method: "POST",
                       headers: {
                       "Content-Type": "application/json",
                       "Accept": "application/json"
                       },
                       body: JSON.stringify(BodyData)
                       })
                       .then(response => response.json())
                       .then(data => {
                          var List = [];
                          $.each(data, function(index, item) {
                             var isExist = List.some(function(currentValue) {
                                return item.color === currentValue.color;
                             });
                             if (!isExist) {
                                List.push(item);
                             }
                          });
                          List.sort(function(a, b) {
                             return parseFloat(a.color) - parseFloat(b.color);
                          });
                          $.each(List, function(i, itemx) {
                             $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').append('<option value="' + itemx.color + '">' + itemx.color + '</option>')
                          })
                       });
                       formControl(ProdcutType)
                  }
                }
                if(ProdcutType==8){
                      var Power = $('[name="Power_'+Position+'"]').val()
                      var Bc    = $('[name="BC_'+Position+'"]').val()
                      
                      $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').html('<option value="0"></option>')
                      const BodyData ={
                        "product_type_id": ProdcutType,
                        "product_id": ProductId,
                        "power": Power,
                        "bc": Bc
                      }
                      window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/addition/' , {
                      method: "POST",
                      headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                      },
                      body: JSON.stringify(BodyData)
                      })
                      .then(response => response.json())
                      .then(data => {
                        var List = [];
                        $.each(data, function(index, item) {
                           var isExist = List.some(function(currentValue) {
                              return item.addition === currentValue.addition;
                           });
                           if (!isExist) {
                              List.push(item);
                           }
                        });
                        List.sort(function(a, b) {
                           return parseFloat(a.addition) - parseFloat(b.addition);
                        });
                        $.each(List, function(i, itemx) {
                           $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').append('<option value="' + itemx.addition + '">' + itemx.addition + '</option>')
                        })
                      });
                      formControl(ProdcutType)
                }
                if(ProdcutType==6){
                    if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
                      var Power = $('[name="Power_'+Position+'"]').val()
                      var Bc    = $('[name="BC_'+Position+'"]').val()
                      
                      $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                             
                      const BodyData ={
                      "product_type_id": ProdcutType,
                      "product_id": ProductId,
                      "power": Power,
                      "bc": Bc
                      }
                      window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                      method: "POST",
                      headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                      },
                      body: JSON.stringify(BodyData)
                      })
                      .then(response => response.json())
                      .then(data => {
                      var List = [];
                      $.each(data, function(index, item) {
                         var isExist = List.some(function(currentValue) {
                            return item.dia === currentValue.dia;
                         });
                         if (!isExist) {
                            List.push(item);
                         }
                      });
                      List.sort(function(a, b) {
                         return parseFloat(a.dia) - parseFloat(b.dia);
                      });
                      $.each(List, function(i, itemx) {
                         $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                      })
                      });
                      formControl(ProdcutType)
                    }else{
                      formControl(ProdcutType)
                    }
                }
              }
           });
          if(ProdcutType==7){
             if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()!=undefined){
               $('.CalcBox .CalcBoxContainer .TableBody select.BC').change(function() {
                  var Position   = $(this).attr("Position")
                  var Power      = $('[name="Power_'+Position+'"]').val()
                  var Bc         = $('[name="BC_'+Position+'"]').val()
      
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/cyl/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.cyl === currentValue.cyl;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.cyl) - parseFloat(b.cyl);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="Cyl_'+Position+'"]').append('<option value="' + itemx.cyl + '">' + itemx.cyl + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
             }
             $('.CalcBox .CalcBoxContainer .TableBody select.CYL').change(function() {
    
                 var Position   = $(this).attr("Position")
                 var Power      = $('[name="Power_'+Position+'"]').val()
                 var Bc         = $('[name="BC_'+Position+'"]').val()
                 var Cyl        = $('[name="Cyl_'+Position+'"]').val()
               
                 $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_'+Position+'"]').html('<option value="0"></option>')
                 $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
      
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc,
                    "cyl": Cyl
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/axis/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.axis === currentValue.axis;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.axis) - parseFloat(b.axis);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="Axis_'+Position+'"]').append('<option value="' + itemx.axis + '">' + itemx.axis + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
             
             $('.CalcBox .CalcBoxContainer .TableBody select.AXIS').change(function() {
                 if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
                   var Position   = $(this).attr("Position")
                   var Power = $('[name="Power_'+Position+'"]').val()
                   var Bc    = $('[name="BC_'+Position+'"]').val()
                   var Cyl   = $('[name="Cyl_'+Position+'"]').val()
                   var Axis  = $('[name="Axis_'+Position+'"]').val()
      
                   $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                   
                   const BodyData ={
                      "product_type_id": ProdcutType,
                      "product_id": ProductId,
                      "power": Power,
                      "bc": Bc,
                      "cyl": Cyl,
                      "axis": Axis
                   }
                   window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                   method: "POST",
                   headers: {
                   "Content-Type": "application/json",
                   "Accept": "application/json"
                   },
                   body: JSON.stringify(BodyData)
                   })
                   .then(response => response.json())
                   .then(data => {
                      var List = [];
                      $.each(data, function(index, item) {
                         var isExist = List.some(function(currentValue) {
                            return item.dia === currentValue.dia;
                         });
                         if (!isExist) {
                            List.push(item);
                         }
                      });
                      List.sort(function(a, b) {
                         return parseFloat(a.dia) - parseFloat(b.dia);
                      });
                      $.each(List, function(i, itemx) {
                         $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                      })
                   });
                   formControl(ProdcutType)
                 }else{
                   formControl(ProdcutType)
                 }
             });
             $('.CalcBox .CalcBoxContainer .TableBody select.DIA').change(function() {
                formControl(ProdcutType)
             });
           }
          if(ProdcutType==11){
           if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.BC').change(function() {
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
    
                  $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/addition/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.addition === currentValue.addition;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.addition) - parseFloat(b.addition);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').append('<option value="' + itemx.addition + '">' + itemx.addition + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
           }
           $('.CalcBox .CalcBoxContainer .TableBody select.ADDITION').change(function() {
             if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
               var Position   = $(this).attr("Position")
               var Power = $('[name="Power_'+Position+'"]').val()
               var Bc    = $('[name="BC_'+Position+'"]').val()
               var Addition   = $('[name="ADDITION_'+Position+'"]').val()
             
               $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
               $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').html('<option value="0"></option>')
               
               const BodyData ={
                  "product_type_id": ProdcutType,
                  "product_id": ProductId,
                  "power": Power,
                  "bc": Bc,
                  "addition": Addition
               }
               window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
               method: "POST",
               headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
               },
               body: JSON.stringify(BodyData)
               })
               .then(response => response.json())
               .then(data => {
                  var List = [];
                  $.each(data, function(index, item) {
                     var isExist = List.some(function(currentValue) {
                        return item.dia === currentValue.dia;
                     });
                     if (!isExist) {
                        List.push(item);
                     }
                  });
                  List.sort(function(a, b) {
                     return parseFloat(a.dia) - parseFloat(b.dia);
                  });
                  $.each(List, function(i, itemx) {
                     $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                  })
               });
               formControl(ProdcutType)
             }else{
               var Position   = $(this).attr("Position")
               var Power = $('[name="Power_'+Position+'"]').val()
               var Bc    = $('[name="BC_'+Position+'"]').val()
               var Dia    = $('[name="DIA_'+Position+'"]').val()
               var Addition   = $('[name="ADDITION_'+Position+'"]').val()
             
               $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').html('<option value="0"></option>')
             
               
               const BodyData ={
                  "product_type_id": ProdcutType,
                  "product_id": ProductId,
                  "power": Power,
                  "bc": Bc,
                  "dia": Dia,
                  "addition": Addition
               }
               window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dn/' , {
               method: "POST",
               headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
               },
               body: JSON.stringify(BodyData)
               })
               .then(response => response.json())
               .then(data => {
                  var List = [];
                  $.each(data, function(index, item) {
                     var isExist = List.some(function(currentValue) {
                        return item.dn === currentValue.dn;
                     });
                     if (!isExist) {
                        List.push(item);
                     }
                  });
                  List.sort(function(a, b) {
                     return parseFloat(a.dn) - parseFloat(b.dn);
                  });
                  $.each(List, function(i, itemx) {
                     $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').append('<option value="' + itemx.dn + '">' + itemx.dn + '</option>')
                  })
               });
               formControl(ProdcutType)
             }
           });
           $('.CalcBox .CalcBoxContainer .TableBody select.DN').change(function() {
               formControl(ProdcutType)
           });
         }
          if(ProdcutType==12){
           
           $('.CalcBox .CalcBoxContainer .TableBody select.BC').change(function() {
             if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
    
                  $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.dia === currentValue.dia;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.dia) - parseFloat(b.dia);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             }else{
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
                 var Dia    = $('[name="DIA_'+Position+'"]').val()
    
                  $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "dia": Dia,
                    "bc": Bc
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/cyl/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.cyl === currentValue.cyl;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.cyl) - parseFloat(b.cyl);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="CYL_'+Position+'"]').append('<option value="' + itemx.cyl + '">' + itemx.cyl + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             }
           });
           $('.CalcBox .CalcBoxContainer .TableBody select.CYL').change(function() {
               var Position   = $(this).attr("Position")
               var Power = $('[name="Power_'+Position+'"]').val()
               var Bc    = $('[name="BC_'+Position+'"]').val()
               var Dia  = $('[name="DIA_'+Position+'"]').val()
               var Cyl   = $('[name="CYL_'+Position+'"]').val()
             
                $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_'+Position+'"]').html('<option value="0"></option>')
                $('.CalcBox .CalcBoxContainer .TableBody [name="COLOR_'+Position+'"]').html('<option value="0"></option>')
    
               const BodyData ={
                  "product_type_id": ProdcutType,
                  "product_id": ProductId,
                  "power": Power,
                  "bc": Bc,
                  "cyl": Cyl,
                  "dia": Dia
               }
               window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/axis/' , {
               method: "POST",
               headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
               },
               body: JSON.stringify(BodyData)
               })
               .then(response => response.json())
               .then(data => {
                  var List = [];
                  $.each(data, function(index, item) {
                     var isExist = List.some(function(currentValue) {
                        return item.axis === currentValue.axis;
                     });
                     if (!isExist) {
                        List.push(item);
                     }
                  });
                  List.sort(function(a, b) {
                     return parseFloat(a.axis) - parseFloat(b.axis);
                  });
                  $.each(List, function(i, itemx) {
                     $('.CalcBox .CalcBoxContainer .TableBody [name="AXIS_'+Position+'"]').append('<option value="' + itemx.axis + '">' + itemx.axis + '</option>')
                  })
               });
               formControl(ProdcutType)
           });
           $('.CalcBox .CalcBoxContainer .TableBody select.AXIS').change(function() {
               var Position   = $(this).attr("Position")
               var Power = $('[name="Power_'+Position+'"]').val()
               var Bc    = $('[name="BC_'+Position+'"]').val()
               var Dia  = $('[name="DIA_'+Position+'"]').val()
               var Cyl   = $('[name="CYL_'+Position+'"]').val()
               var Axis   = $('[name="AXIS_'+Position+'"]').val()
             
                $('.CalcBox .CalcBoxContainer .TableBody [name="COLOR_'+Position+'"]').html('<option value="0"></option>')
    
               const BodyData ={
                  "product_type_id": ProdcutType,
                  "product_id": ProductId,
                  "power": Power,
                  "bc": Bc,
                  "cyl": Cyl,
                  "axis": Axis,
                  "dia": Dia
               }
               window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/color/' , {
               method: "POST",
               headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
               },
               body: JSON.stringify(BodyData)
               })
               .then(response => response.json())
               .then(data => {
                  var List = [];
                  $.each(data, function(index, item) {
                     var isExist = List.some(function(currentValue) {
                        return item.color === currentValue.color;
                     });
                     if (!isExist) {
                        List.push(item);
                     }
                  });
                  List.sort(function(a, b) {
                     return parseFloat(a.color) - parseFloat(b.color);
                  });
                  $.each(List, function(i, itemx) {
                     $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').append('<option value="' + itemx.color + '">' + itemx.color + '</option>')
                  })
               });
               formControl(ProdcutType)
           });
           $('.CalcBox .CalcBoxContainer .TableBody select.COLOR').change(function() {
              formControl(ProdcutType)
           });
         }
          if(ProdcutType==9){
           if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.BC').change(function() {
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
    
                  $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.dia === currentValue.dia;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.dia) - parseFloat(b.dia);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
           }
           if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.DIA').change(function() {
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
                 var Dia   = $('[name="DIA_'+Position+'"]').val()
               
                  $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').html('<option value="0"></option>')
               
                 
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc,
                    "dia": Dia
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/color/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.color === currentValue.color;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.color) - parseFloat(b.color);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="Color_'+Position+'"]').append('<option value="' + itemx.color + '">' + itemx.color + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
           }
           $('.CalcBox .CalcBoxContainer .TableBody select.COLOR').change(function() {
              formControl(ProdcutType)
           });
         }
          if(ProdcutType==8){
           if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.BC').change(function() {
                 var Position   = $(this).attr("Position")
                 var Power = $('[name="Power_'+Position+'"]').val()
                 var Bc    = $('[name="BC_'+Position+'"]').val()
    
                  $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').html('<option value="0"></option>')
                  $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                           
                 const BodyData ={
                    "product_type_id": ProdcutType,
                    "product_id": ProductId,
                    "power": Power,
                    "bc": Bc
                 }
                 window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/addition/' , {
                 method: "POST",
                 headers: {
                 "Content-Type": "application/json",
                 "Accept": "application/json"
                 },
                 body: JSON.stringify(BodyData)
                 })
                 .then(response => response.json())
                 .then(data => {
                    var List = [];
                    $.each(data, function(index, item) {
                       var isExist = List.some(function(currentValue) {
                          return item.addition === currentValue.addition;
                       });
                       if (!isExist) {
                          List.push(item);
                       }
                    });
                    List.sort(function(a, b) {
                       return parseFloat(a.addition) - parseFloat(b.addition);
                    });
                    $.each(List, function(i, itemx) {
                       $('.CalcBox .CalcBoxContainer .TableBody [name="ADDITION_'+Position+'"]').append('<option value="' + itemx.addition + '">' + itemx.addition + '</option>')
                    })
                 });
                 formControl(ProdcutType)
             });
           }
           $('.CalcBox .CalcBoxContainer .TableBody select.ADDITION').change(function() {
             if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
               var Position   = $(this).attr("Position")
               var Power = $('[name="Power_'+Position+'"]').val()
               var Bc    = $('[name="BC_'+Position+'"]').val()
               var Addition   = $('[name="ADDITION_'+Position+'"]').val()
             
               $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
               
               const BodyData ={
                  "product_type_id": ProdcutType,
                  "product_id": ProductId,
                  "power": Power,
                  "bc": Bc,
                  "addition": Addition
               }
               window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
               method: "POST",
               headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
               },
               body: JSON.stringify(BodyData)
               })
               .then(response => response.json())
               .then(data => {
                  var List = [];
                  $.each(data, function(index, item) {
                     var isExist = List.some(function(currentValue) {
                        return item.dia === currentValue.dia;
                     });
                     if (!isExist) {
                        List.push(item);
                     }
                  });
                  List.sort(function(a, b) {
                     return parseFloat(a.dia) - parseFloat(b.dia);
                  });
                  $.each(List, function(i, itemx) {
                     $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                  })
               });
               formControl(ProdcutType)
             }else{
               var Position   = $(this).attr("Position")
               var Power = $('[name="Power_'+Position+'"]').val()
               var Bc    = $('[name="BC_'+Position+'"]').val()
               var Dia    = $('[name="DIA_'+Position+'"]').val()
               var Addition   = $('[name="ADDITION_'+Position+'"]').val()
             
               $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').html('<option value="0"></option>')
             
               
               const BodyData ={
                  "product_type_id": ProdcutType,
                  "product_id": ProductId,
                  "power": Power,
                  "bc": Bc,
                  "dia": Dia,
                  "addition": Addition
               }
               window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dn/' , {
               method: "POST",
               headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
               },
               body: JSON.stringify(BodyData)
               })
               .then(response => response.json())
               .then(data => {
                  var List = [];
                  $.each(data, function(index, item) {
                     var isExist = List.some(function(currentValue) {
                        return item.dn === currentValue.dn;
                     });
                     if (!isExist) {
                        List.push(item);
                     }
                  });
                  List.sort(function(a, b) {
                     return parseFloat(a.dn) - parseFloat(b.dn);
                  });
                  $.each(List, function(i, itemx) {
                     $('.CalcBox .CalcBoxContainer .TableBody [name="DN_'+Position+'"]').append('<option value="' + itemx.dn + '">' + itemx.dn + '</option>')
                  })
               });
               formControl(ProdcutType)
             }
           });
           $('.CalcBox .CalcBoxContainer .TableBody select.DN').change(function() {
               formControl(ProdcutType)
           });
           if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.DIA').change(function() {
                formControl(ProdcutType)
             });
           }
         }
          if(ProdcutType==6){
           if($('.CalcBox .CalcBoxContainer .TableBody select.BC').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.BC').change(function() {
                 if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
                   var Position   = $(this).attr("Position")
                   var Power = $('[name="Power_'+Position+'"]').val()
                   var Bc    = $('[name="BC_'+Position+'"]').val()
      
                    $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').html('<option value="0"></option>')
                             
                   const BodyData ={
                      "product_type_id": ProdcutType,
                      "product_id": ProductId,
                      "power": Power,
                      "bc": Bc
                   }
                   window.lensCatalogRequest(ApiUrl + 'product/'+ProdcutType+'/dia/' , {
                   method: "POST",
                   headers: {
                   "Content-Type": "application/json",
                   "Accept": "application/json"
                   },
                   body: JSON.stringify(BodyData)
                   })
                   .then(response => response.json())
                   .then(data => {
                      var List = [];
                      $.each(data, function(index, item) {
                         var isExist = List.some(function(currentValue) {
                            return item.dia === currentValue.dia;
                         });
                         if (!isExist) {
                            List.push(item);
                         }
                      });
                      List.sort(function(a, b) {
                         return parseFloat(a.dia) - parseFloat(b.dia);
                      });
                      $.each(List, function(i, itemx) {
                         $('.CalcBox .CalcBoxContainer .TableBody [name="DIA_'+Position+'"]').append('<option value="' + itemx.dia + '">' + itemx.dia + '</option>')
                      })
                   });
                   formControl(ProdcutType)
                 }else{
                   formControl(ProdcutType)
                 }
             });
           }
           if($('.CalcBox .CalcBoxContainer .TableBody select.DIA').html()!=undefined){
             $('.CalcBox .CalcBoxContainer .TableBody select.DIA').change(function() {
                formControl(ProdcutType)
             });
           }
         }
        }
  
   
       
      
   }).catch(function(error) {
      window.lensCatalogShowError()
      console.warn("Lens seçenekleri geçici olarak yüklenemedi.")
   })

  console.log("ProdcutType2",ProdcutType)
   
   $(document).on("change", ".CalcBox .CalcBoxContainer .TableBody [name='BOX_LeftRight'],.CalcBox .CalcBoxContainer .TableBody [name='BOX_Left'],.CalcBox .CalcBoxContainer .TableBody [name='BOX_Right']", function() {
     var TYPE = $(".CalcBox").attr("T") 
     var QU = 0
     if(TYPE==0){
        var BOX_Left      = parseInt($(".CalcBox .CalcBoxContainer .TableBody [name='BOX_Left']").val())
        var BOX_Right     = parseInt($(".CalcBox .CalcBoxContainer .TableBody [name='BOX_Right']").val())
       QU = BOX_Left + BOX_Right
     }
     if(TYPE==1){
        var BOX_LeftRight = parseInt($(".CalcBox .CalcBoxContainer .TableBody [name='BOX_LeftRight']").val())
       QU = BOX_LeftRight
     }
     $('[name="quantity"]').val(QU)
   })
})



$(document).on("click", function(event) {
    // Tıklanan elementin "SelectedInput" sınıfına sahip bir üst elemanı olup olmadığını kontrol et
    var selectedInput = $(event.target).closest('.SelectedInput');

    // Tıklanan element veya üst eleman "SelectedInput" sınıfına sahipse
    if (selectedInput.length > 0) {
        // .SelectedInput içine veya içindeki elemanlarına tıklanmıştır, hiçbir işlem yapma
        return;
    }

    // .SelectedInput dışına tıklanmıştır, "Active" sınıfını kaldır
    $(".SelectedInput").removeClass("Active");
});

$(document).on("click",'.CalcBox .CalcBoxContainer .TableBody .SelectedInput .SelectedInputWind ul>li',function(){
  $(".SelectedInput").removeClass("Active")
})
$('.CalcBox .CalcBoxContainer .TableBody .SelectedInput input').click(function(){
  $(".SelectedInput").removeClass("Active")
  $(this).closest(".SelectedInput").addClass("Active")
})

  
/*  <!-- Ürün açıklaması FAQ js kodu --> */
  
 document.addEventListener("DOMContentLoaded", function () {
    var faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach(function (item) {
      var question = item.querySelector(".question-text");
      var answer = item.querySelector(".answer-text");
      var toggleIcon = item.querySelector(".toggle");

      if (!question || !answer || !toggleIcon) return;

      question.addEventListener("click", function () {
        var isExpanded = answer.classList.contains("show");
        var maxHeight = isExpanded ? 0 : answer.scrollHeight + "20px";

        answer.style.maxHeight = maxHeight;
        answer.classList.toggle("show");
        toggleIcon.textContent = isExpanded ? "+" : "-";
      });
    });
  });

/*  <!-- Ürün açıklaması FAQ js kodu --> */


/* form kontrolü */

document.addEventListener('DOMContentLoaded', function() {
    // Form container'ı seç
    const formContainer = document.querySelector('.CalcBox.Desktop');
    if (!formContainer) return;

    // Tekrardan seçenek alanı eklememek için kontrol
    if (document.querySelector('.prescription-options')) return;

    // Önce mevcut alanların görünürlüğünü ayarla
    const calcBoxContainer = formContainer.querySelector('.CalcBoxContainer');
    const uploadSection = document.querySelector('div[style*="background-color: #0348c6"]');

    // Form ve yükleme alanlarını ayarla (calcBoxContainer varsayılan olarak görünür)
    if (calcBoxContainer) {
        calcBoxContainer.style.cssText = 'display: block;';
    }

    if (uploadSection) {
        uploadSection.style.cssText = 'display: none; background-color: #0348c6; padding: 13px;';
    }

    // Seçenek alanını oluştur ve ekle
    formContainer.insertAdjacentHTML('beforebegin', `
        <div class="prescription-options" style="margin-bottom: 20px;">
            <div style="font-size: 20px;font-weight:700; color: #0348c6; margin-bottom: 15px;">
                Bir seçenek belirleyin:
            </div>
            <div style="display: flex; flex-direction: column; gap: 12px;">
                <label style="display: flex; align-items: center; gap: 10px;">
                    <span style="position: relative; display: inline-block; width: 40px; height: 20px;">
                        <input
                            type="radio"
                            name="prescriptionOption"
                            value="upload"
                            style="opacity: 0; width: 0; height: 0;"
                        />
                        <span class="switcher"></span>
                    </span>
                    <span style="color: #0348c6; font-size: 14px;font-weight:700;">
                        Mevcut Reçetemin Bir Fotoğrafını Yükleyeceğim.
                    </span>
                </label>
                <label style="display: flex; align-items: center; gap: 10px;">
                    <span style="position: relative; display: inline-block; width: 40px; height: 20px;">
                        <input
                            type="radio"
                            name="prescriptionOption"
                            value="manual"
                            style="opacity: 0; width: 0; height: 0;"
                            checked
                        />
                        <span class="switcher"></span>
                    </span>
                    <span style="color: #0348c6; font-size: 14px;font-weight:700;">
                        Bilgilerimi Kendim Dolduracağım.
                    </span>
                </label>
            </div>
        </div>
    `);

    // Radio butonlarına event listener ekle
    document.querySelectorAll('input[name="prescriptionOption"]').forEach(radio => {
        radio.addEventListener('change', function() {
            // Önce hepsini gizle
            if (calcBoxContainer) calcBoxContainer.style.display = 'none';
            if (uploadSection) uploadSection.style.display = 'none';

            // Seçime göre göster
            if (this.value === 'upload') {
                if (uploadSection) uploadSection.style.display = 'block';
            } else if (this.value === 'manual') {
                if (calcBoxContainer) calcBoxContainer.style.display = 'block';
            }
        });
    });

    // Debug için konsola durum yazdır
    console.log('Form container bulundu:', !!formContainer);
    console.log('Calc box container bulundu:', !!calcBoxContainer);
    console.log('Upload section bulundu:', !!uploadSection);

    // Switcher için stil ekle
    const style = document.createElement('style');
    style.textContent = `
        .switcher {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            border-radius: 34px;
            transition: 0.4s;
        }

        .switcher:before {
            position: absolute;
            content: "";
            height: 14px;
            width: 14px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            transition: 0.4s;
            border-radius: 50%;
        }

        input:checked + .switcher {
            background-color: #09df3f;
        }

        input:checked + .switcher:before {
            transform: translateX(20px);
        }
    `;
    document.head.appendChild(style);
});

/* form kontrolü */

/* Form Kontrolü Mobil */
document.addEventListener('DOMContentLoaded', function () {
    // Mobil alanını seç
    const formContainer = document.querySelector('.CalcBox.Mobil');
    if (!formContainer) {
        console.error("Mobil alan bulunamadı.");
        return;
    }

    // Daha önce seçenek eklenmişse tekrardan ekleme
    if (document.querySelector('.prescription-options')) return;

    // Gerekli alanları seç
    const calcBoxContainer = formContainer.querySelector('.CalcBoxContainer');
    const uploadSection = formContainer.querySelector('.OrWrapper');
    const warningText = document.querySelector('.warning-text');
    const orContainer = document.querySelector('.Or');

    // Mevcut alanları başlangıçta ayarla (calcBoxContainer görünür olacak)
    if (calcBoxContainer) calcBoxContainer.style.cssText = 'display: block;';
    if (uploadSection) uploadSection.style.cssText = 'display: none;';
    if (warningText) warningText.style.cssText = 'display: none;';
    if (orContainer) orContainer.style.cssText = 'display: none;';

    // Yeni seçenek alanını ekle
    formContainer.insertAdjacentHTML('beforebegin', `
        <div class="prescription-options" style="margin-bottom: 20px;">
            <div style="font-size: 20px;font-weight:700; color: #0348c6; margin-bottom: 15px;">
                Bir seçenek belirleyin:
            </div>
            <div style="display: flex; flex-direction: column; gap: 12px;">
                <label style="display: flex; align-items: center; gap: 10px;">
                    <span style="position: relative; display: inline-block; width: 40px; height: 20px;">
                        <input
                            type="radio"
                            name="prescriptionOption"
                            value="upload"
                            style="opacity: 0; width: 0; height: 0;"
                        />
                        <span class="switcher"></span>
                    </span>
                    <span style="color: #0348c6; font-size: 14px;font-weight:700;">
                        Reçete Görselini Yükleyeceğim.
                    </span>
                </label>
                <label style="display: flex; align-items: center; gap: 10px;">
                    <span style="position: relative; display: inline-block; width: 40px; height: 20px;">
                        <input
                            type="radio"
                            name="prescriptionOption"
                            value="manual"
                            style="opacity: 0; width: 0; height: 0;"
                            checked
                        />
                        <span class="switcher"></span>
                    </span>
                    <span style="color: #0348c6; font-size: 14px;font-weight:700;">
                        Reçeteyi Kendim Gireceğim.
                    </span>
                </label>
            </div>
        </div>
    `);

    // Radio butonlarına event listener ekle
    document.querySelectorAll('input[name="prescriptionOption"]').forEach(radio => {
        radio.addEventListener('change', function () {
            // Önce tüm alanları gizle
            if (calcBoxContainer) calcBoxContainer.style.display = 'none';
            if (uploadSection) uploadSection.style.display = 'none';
            if (warningText) warningText.style.display = 'none';

            // Seçime göre alanı göster
            if (this.value === 'upload') {
                if (uploadSection) uploadSection.style.display = 'block';
            } else if (this.value === 'manual') {
                if (calcBoxContainer) calcBoxContainer.style.display = 'block';
            }
        });
    });

    // Switcher stilini ekle
    const style = document.createElement('style');
    style.textContent = `
        .switcher {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            border-radius: 34px;
            transition: 0.4s;
        }

        .switcher:before {
            position: absolute;
            content: "";
            height: 14px;
            width: 14px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            transition: 0.4s;
            border-radius: 50%;
        }

        input:checked + .switcher {
            background-color: #09df3f;
        }

        input:checked + .switcher:before {
            transform: translateX(20px);
        }
    `;
    document.head.appendChild(style);

    console.log('Script başarıyla çalıştırıldı.');
});

/* Form Kontrolü Mobil */
